export default {
  SET_lastOperation: (state, operation) => {
    state.lastOperation = operation;
  },
};
